import styled from "styled-components";
import "@fontsource/lexend";
import "@fontsource/bebas-neue";
import "@fontsource/merriweather";
import "@fontsource/montserrat"; 

export const LandingPageContainer = styled.div`
    background: #282c34;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0;
    height: 100vh;
    position: relative;
    z-index: 1;
    
    @media screen and (max-width: 900px) { 
        height: 1250px;
    }
    
    @media screen and (max-width: 800px) { 
        height: 1100px;
    }
        
    @media screen and (max-width: 700px) { 
        height: 935px;
    }
`;

export const LandingPageSimpleContainer = styled.div`
    background:rgb(0, 0, 0);
    display: flex;
    justify-content: center;
    align-items: center;
    padding-bottom: 60px;
    padding-top: 50px;
`;

export const LandingPageSimpleButtonsContainer = styled.div`
background:rgb(0, 0, 0);
display: flex;
justify-content: center;
align-items: center;
padding-bottom: 0;
`;

export const LandingPageSecondContainer = styled.div`
background:rgb(0, 0, 0);
display: flex;
justify-content: center;
align-items: center;
height: 1400px;
z-index: 1;
padding-top: 80px;

@media screen and (max-width: 900px) { 
    height: 1250px;
    padding-top: 0;
}

@media screen and (max-width: 800px) { 
    height: 1100px;
    padding-top: 0;
}
    
@media screen and (max-width: 700px) { 
    height: 935px;
    padding-top: 0;
}
`;

export const RecommendationsContainer = styled.div`
 background: rgb(0, 0, 0);
 display: flex;
 justify-content: center;
 align-items: center;
 width: 100%;

 padding: 0 0 40px 0;
 overflow: hidden;     
 z-index: 1;
`;

export const LandingPageOverlay = styled.div`
  position: absolute;
  inset: 0; /* top:0; right:0; bottom:0; left:0 */
  background: rgba(0, 0, 0, 0.40); /* 30% black */
  z-index: 2; /* sits above video but below text */
`;
export const LandingPageSecondContent = styled.div`
    z-index: 3;
    padding: 8px 24px;
    padding-top: 30px;
    display: flex;
    flex-direction: column;
    align-items: center;
    background:rgb(0, 0, 0);
`;


export const LandingPageBg = styled.div`
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    width:100%;
    height: 100%;
    overflow: hidden;
`;

export const LandingPageImage = styled.img`
    width: 100%;
    height: 100%;
    -o-object-fit: cover;
    object-fit: cover;
    background: #282c34;
`;

export const RecommendationsImage = styled.img`
display: block;       
  width: 40%; 
  height: auto;      
  object-fit: contain;
  background: #282c34;

  @media screen and (max-width: 768px) {
      width: 100%;
  }
`;


export const LandingPageLogoImage = styled.img`
    width: 20%;
    height: auto;
    -o-object-fit: cover;
    object-fit: cover;
    @media screen and (max-width: 768px) {
      width: 45%;
    }
`;

export const LandingPageContent = styled.div`
  position: absolute;
  margin-top: -80px;
  z-index: 3;
  padding: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`;

export const LandingPageTitle = styled.h2`
  font-family: "Merriweather";
  font-weight: 400;
  color: #ffffff;
  text-align: center;
  line-height: 1.25;
  padding-top: 140px; /* default desktop padding */

  font-size: 50px;

  @media screen and (max-width: 1024px) {
    font-size: 54px;
  }

  @media screen and (max-width: 768px) {
    font-size: 36px;
  }

  @media screen and (max-width: 480px) {
    font-size: 24px;
  }
`;

export const LandingPageBottomText = styled.div`
  position: absolute;
  bottom: 120px;   /* distance from bottom of container */
  left: 50%;
  transform: translateX(-50%);
  z-index: 3;
  font-family: "Montserrat", sans-serif;
  font-weight: 500;
  font-size: 20px;
  color: #ffffff;
  text-align: center;
  letter-spacing: 2px;

  @media screen and (max-width: 768px) {
    font-size: 16px;
    bottom: 20px;
  }
`;


export const LandingPageSubTitle = styled.h3`
    color: #f0f0f0;
    font-size: 24px;
    text-align: center;
    font-family: "Lexend";
    font-weight: 1000;
    
   @media screen and (max-width: 768px) { 
        font-size: 26px;
        font-family: "Bebas Neue";
        font-weight: 400;
    }
    
   @media screen and (max-width: 480px) { 
        font-size: 24px;
        font-family: "Bebas Neue";
        font-weight: 400;
    }
`;

export const LandingPageSubText = styled.h3`
    color: #f0f0f0;
    font-size: 20px;
    text-align: center;
    font-family: "montserrat";
    font-weight: 100;
    max-width: 60%;
    
   @media screen and (max-width: 768px) { 
        font-size: 18px;
        text-align: left;
        max-width: 100%;
    }
    
   @media screen and (max-width: 480px) { 
        font-size: 16px;
        text-align: left;
        max-width: 100%;
    }
`;

export const LandingPageText = styled.div`
    color: #f3f3f3;
    font-size: 24px;
    text-align: center;
    font-family: "montserrat";
   
   @media screen and (max-width: 480px) { 
        font-size: 16px;
    }
`;

export const LandingPageSmallerText = styled.div`
    color: #f3f3f3;
    font-size: 18px;
    text-align: center;
    font-family: "Bebas Neue";
   
   @media screen and (max-width: 480px) { 
        font-size: 14px;
    }
`;

export const LandingPageButtonRow = styled.div`
  margin-top: 40px;
  display: flex;
  justify-content: center;
  gap: 60px;
  flex-wrap: wrap; 
`;

